
import "../css/platform.css";

import "../css/Purchase.css";
import "../css/login.css";

import { Header } from './../common/Header';
import { PreOrder, Notice, LogInPromptContainer } from './../common/Components';

import { Color, TextColor, BackgroundColor } from "@Beasted1010/pivotal-wisdom"

import { ProductsContextProvider } from "../context/ProductsContext";
import { useProducts, useProductsUpdate } from "../context/ProductsContext";

import { useUser } from "../context/UserContext";

import { useRef, useState } from "react";


/*
================================================================================
================================================================================
================================================================================
    TODO: Make "Promo Code" Features a "Coming Soon" Feature (dev post Release)
================================================================================
================================================================================
================================================================================
*/


export { Purchase };
function Purchase() {

  return (
    <>
      <Header content={<HeaderContent />} />

      <ProductsContextProvider>
        <Main />
      </ProductsContextProvider>
    </>
  );
}


function HeaderContent() {
  return (
    <div className="purchase_header_content_container">
      <div className="purchase_header_content">
        <h1 className="purchase_header_content_heading">The Pivotal Purchase</h1>
        <p className="purchase_header_content_slogan">Clear. Concise. Practical.</p>
      </div>
    </div>
  );
}



/* Move to a "types.tsx" File under ".../common/"? */
/* TODO NOTE: Move to Types File */
interface IPrice {
  price: string;
  originalPrice?: string | undefined;
}

enum PromoCodeType { // TODO: These should come from the Server !! -- To avoid Spoofing
  HOLIDAY = "HOLIDAYBUZZ"
}




function Main() {
  const { user } = useUser();

  return (
    <main className="platform_body purchase_body">

      {/*<BaseSubscription />*/}

      <Products />

      {
        user == null ?
          <LogInPromptContainer logInTo="purchase" description="Your Platform Login will be the Account you're logged in with at the time of purchase." />
        :
          <CheckoutContainer />
      }
    </main>
  );
}


/* =========================== BASE SUBSCRIPTION =========================== */
// TODO - V3


/* =========================== PRODUCTS =========================== */
function Products() {

  const { products } = useProducts();

  return (
    <div className="purchase_body_products_container">
      {products.map( (product, index) => {
        return <Product
                  name={product.name}
                  color={product.color}
                  price={product.price}
                  originalPrice={product.originalPrice}
                  featureList={product.featureList}
                  isPreOrder={product.isPreOrder}
                  key={index} />

      })}
    </div>
  );
}


function handleSelectProduct( event: any ) {
  //const product =
  //addProduct(product);
}

function Product( {name, color, price, originalPrice, featureList, isPreOrder}: IProduct ) {

  const { products, selectedProducts } = useProducts();
  const { addProduct, removeProduct } = useProductsUpdate();

  const product = {name, color, price, originalPrice, featureList, isPreOrder}

  const backgroundColor = BackgroundColor[color as Color];

  const updateProducts = () => {
    const productSelected = selectedProducts.some( product => product.name === name );
    if( productSelected ) return; // Don't do anything if Product already selected

    addProduct(product);
  }

  return (
    <div className="purchase_body_product">
      { isPreOrder && <PreOrder /> }
      <h3 className={`purchase_body_product_name ${backgroundColor}`}>{name}</h3>

      <Price price={price} originalPrice={originalPrice} />
      <h3 className="purchase_body_product_access">1 Year Access</h3>

      <IntroVideoButton color={color} />

      <ul className="purchase_body_product_features">
        {featureList?.map( (feature, index) => {
          return <li className="purchase_body_product_feature" key={index}>{feature}</li>
        })}
      </ul>

      <button onClick={updateProducts} className={`purchase_body_product_select_button ${backgroundColor}`}>
        Select
      </button>
    </div>
  );
}


function Price( {price, originalPrice}: IPrice ) {
  return (
    <div className="purchase_body_product_price">
      <span className="purchase_body_product_dollar-sign">$</span>
      <span className="purchase_body_product_current-price">{price}</span>
      {originalPrice && <span className="purchase_body_product_original-price">${originalPrice}</span>}
    </div>
  );
}

function IntroVideoButton( {color}: {color: Color} ) {
  return (
    <button className={`purchase_body_product_intro-video_button ${BackgroundColor[color]}`}>
      Watch Intro Video
    </button>
  );
}



/* =========================== CHECKOUT CONTAINER =========================== */

function CheckoutContainer() {
  return (
    <div className="purchase_body_checkout_container">
      <Checkout />
      <OrderSummary />
    </div>
  );
}

function Checkout() {
  return (
    <div className="purchase_body_checkout_form">
      <h2 className="purchase_body_checkout_form_header">Checkout</h2>
      <BreadCrumbs />

      { /* TODO: Below varies based on what Page on during Checkout */ }
      <ProductSelection />
      { /* TODO: Make a Configurable Field. E.g. "ProductBundleNotice" in some "Site Config JSON" from Server */ }
      <Notice content="Select 2 Products for 20% off and 3+ Products for 25% off"/>

      <Navigation currentPage={2} />
    </div>
  );
}

function OrderSummary() {
  return (
    <div className="purchase_body_checkout_order-summary">
      <h2 className="purchase_body_checkout_order-summary_header">Order Summary</h2>

      <SelectedProducts />
      <Discounts />
      <hr/>
      <Total />
      <PromoCode />
    </div>
  );
}



function BreadCrumbs() {
  return (
    <ol className="purchase_body_checkout_form_bread-crumbs">
      <li className="selected">Product<br/>Selection</li>
      <li>Payment<br/>Method</li>
      <li>Payment<br/>Form</li>
      <li>Payment<br/>Success</li>
    </ol>
  );
}

function ProductSelection() {
  const { products } = useProducts();

  return (
    <div className="purchase_body_checkout_form_product-selection">
      {products.map( (product, index) => {
        return <SelectableProduct
                  name={product.name}
                  color={product.color}
                  price={product.price}
                  originalPrice={product.originalPrice}
                  key={index} />

      })}
    </div>
  );
}

function Navigation( {currentPage}: {currentPage: number} ) {
  return (
    <div className="purchase_body_checkout_form_navigation">
      {currentPage > 1 && <button className="purchase_body_checkout_form_prev_button">&larr; Back</button>}
      <button className="purchase_body_checkout_form_next_button">Continue &rarr;</button>
    </div>
  );
}


interface ISelectableProduct { // TODO: COME BACK TO, to see if need, can just use IProduct?
  name: string;
  color: Color;
  price: string;
  originalPrice?: string;
}
function SelectableProduct( {name, color, price, originalPrice }: ISelectableProduct ) {

  const { products, selectedProducts } = useProducts();
  const { addProduct, removeProduct } = useProductsUpdate();

  const isChecked = selectedProducts.some( product => {
    return product.name === name;
  });
  const product = {name, color, price, originalPrice}

  const updateProducts = () => {
    const productSelected = selectedProducts.some( product => product.name === name );
    if( productSelected ) {
      removeProduct(product);
      return;
    }

    addProduct(product);
  }

  return (
    <div onClick={updateProducts} className="purchase_body_checkout_form_selectable-product">
      <input type="checkbox" readOnly checked={isChecked} className="purchase_body_checkout_form_selectable-product_checkbox" />
      <h3 className={`purchase_body_checkout_form_selectable-product_name ${TextColor[color]}`}>{name}</h3>
      <SelectableProductPrice price={price} originalPrice={originalPrice} />
    </div>
  );
}

function SelectableProductPrice( {price, originalPrice}: IPrice ) {
  return (
    <div className="purchase_body_selectable-product_price">
      <span className="purchase_body_selectable-product_current-price">${price}</span>
      {originalPrice && <span className="purchase_body_selectable-product_original-price">${originalPrice}</span>}
    </div>
  );
}




function SelectedProducts() {
  const { products, selectedProducts } = useProducts();
  const { addProduct, removeProduct } = useProductsUpdate();

  return (
    <div className="purchase_body_checkout_order-summary_selected-products">

      {selectedProducts.map( (product, index) => {
        return <SelectedProduct
                  name={product.name}
                  color={product.color}
                  price={product.price}
                  key={index} />
      })}

      {/*<SelectedProduct name="Fitness" color={TextColor.ElectricUltramarine} price="59" />
      <SelectedProduct name="Nutrition" color={TextColor.FashionFuchsia} price="39" />*/}
    </div>
  );
}

function SelectedProduct( {name, color, price, originalPrice}: ISelectableProduct ) {
  return (
    <div className="purchase_body_checkout_order-summary_selected-product">
      <h4 className={`purchase_body_checkout_order-summary_selected-product_name ${TextColor[color]}`}>{name}</h4>
      <SelectedProductPrice price={price} originalPrice={originalPrice} />
    </div>
  );
}

function SelectedProductPrice( {price, originalPrice}: IPrice ) {
  return (
    <div className="purchase_body_selected-product_price">
      <span className="purchase_body_selected-product_dollar-sign">$</span>
      <span className="purchase_body_selected-product_current-price">{price}</span>
      {originalPrice && <span className="purchase_body_selected-product_original-price">${originalPrice}</span>}
    </div>
  );
}


interface IDiscount {
  name: string;
  amount: number;
}
function Discounts() {
  // TODO: THIS DATA NEEDS TO COME FROM THE SERVER!!! -- Or else manipulate it
  // --- Can calculate on Server as well anyways? This just purely for Client Visualization?

  const discounts: IDiscount[] = [];
  const { selectedProducts } = useProducts();

  const productDiscounts = calculateProductDiscounts( selectedProducts );
  discounts.push( {name: "All Product Discounts", amount: productDiscounts} );
  //console.log("DISCOUNTS", productDiscounts); // TODO: This prints TWICE each Render (?? WHY ??) - Same for Total

  const bundleDiscount = calculateBundleDiscount( selectedProducts );
  const bundleDiscountName = selectedProducts.length <= 2 ? "2x Bundle Discount" : "3x Bundle Discount"
  discounts.push({
    name: bundleDiscountName,
    amount: bundleDiscount
  });


  return (
    <div className="purchase_body_checkout_order-summary_discounts">
      {/* TODO: LOOP OVER EACH DISCOUNT -- Make Interface? Type & Price & OrigPrice ???*/}
      {discounts.map( (discount, index) => {
        return <Discount name={discount.name} amount={discount.amount} key={index} />
      })}
    </div>
  );
}

function Discount( {name, amount}: IDiscount ) {
  if( amount == 0 ) return <></>;

  return (
    <div className="purchase_body_checkout_order-summary_discount">
      <h4 className="purchase_body_checkout_order-summary_discount-type">{name}</h4>
      <h4 className="purchase_body_checkout_order-summary_discount-amount">-${amount}</h4>
    </div>
  );
}

function Total() {
  const { selectedProducts } = useProducts();

  let discount = calculateBundleDiscount( selectedProducts );
  //discount += calculatePromoCodeDiscount( ... );
  const total = calculateOrderTotal( selectedProducts, discount );
  //console.log("TOTAL", total); // TODO: This prints TWICE each Render (?? WHY ??) - Same for Discounts

  return (
    <div className="purchase_body_checkout_order-summary_total">
      <h4 className="purchase_body_checkout_order-summary_total-title">Total</h4>
      <h4 className="purchase_body_checkout_order-summary_total-amount">${total}</h4>
    </div>
  );
}

function PromoCode() {

  // TODO: Currently Promo Code has no way to link back to "Total"
  // --------- liftStateUp? Context? - Prob LiftStateUp, since only one value
  const promoCodeRef = useRef<HTMLInputElement>(null);
  const [promoCode, setPromoCode] = useState<string>();

  const { products, selectedProducts } = useProducts();

  const handleApplyPromoCode = () => {
    if( !promoCodeRef || !promoCodeRef.current ) return;
    setPromoCode( promoCodeRef.current.value );
  }

  return (
    <div className="purchase_body_checkout_order-summary_promo-code">
      <h4 className="purchase_body_checkout_order-summary_promo-code_title">Promo Code (optional)</h4>
      <input
        ref={promoCodeRef}
        placeholder="Promo code"
        type="text"
        className="purchase_body_checkout_order-summary_promo-code_input" />
      <button onClick={handleApplyPromoCode} className="purchase_body_checkout_order-summary_promo-code_apply-button">Apply Promo Code</button>

      {/*TODO: TEMP - For Testing, may use initially to leverage Stripe Checkout Prebuilt*/}
      <button onClick={() => makePayment(products)}> CHECKOUT NOW </button> {/*TEMP TODO REMOVE */}
    </div>
  );
}


/* =========================== HELPERS =========================== */

// TODO: Move this to "checkout.tsx" -- in "services" Folder? (i.e. treat as "Service"?)
function makePayment( products: IProduct[] ) {

  const purchaseURI = "http://localhost:7777/payment";

  // Good FETCH API Video: https://www.youtube.com/watch?v=cuEtnrL9-H0
  fetch( purchaseURI, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: products.map( product => {
        //return { id: product.name, quantity: 1 };
        return { id: 1, quantity: 1 }; // TODO: Need some ID as Number on Product...
      })
    })
  }).then( response => {
    if( response.ok ) return response.json(); // Convert to JSON and return
    return response.json().then( json => Promise.reject(json) ); // Fetch doesn't fail on it's own (see above video)
  }).then( ({url}) => {
    window.location = url; // Navigate to that URL specificed (needs given from Server)

    const params = new URLSearchParams( window.location.search );
    const checkoutSessionID = params.get("id");
    //console.log( "Checkout Session ID", checkoutSessionID );

  }).catch( error => {
    console.error( error.error );
  });
}

function calculateOrderTotal( selectedProducts: IProduct[], discount: number = 0 ) {
  const total = selectedProducts.reduce( (accumulator, product) => {
    return accumulator + Number(product.price);
  }, 0);

  return total - discount;
}

function calculateProductDiscounts( selectedProducts: IProduct[] ) {
  return selectedProducts.reduce( (accumulator, product) => {
    if( product.originalPrice == null ) return accumulator;

    const discount = Number(product.originalPrice) - Number(product.price);
    if( discount < 0 ) {
      // TODO: Better Error Handle ?
      console.error("Current Price is greater than Original Price");
    }

    return accumulator + discount;
  }, 0);
}

function calculateBundleDiscount( selectedProducts: IProduct[] ) {
  const orderTotal = calculateOrderTotal( selectedProducts );

  let bundleDiscount = 0;
  if( selectedProducts.length == 2 ) {
    bundleDiscount = Math.ceil(orderTotal * 0.20);
  }
  else if( selectedProducts.length >= 3 ) {
    bundleDiscount = Math.ceil(orderTotal * 0.25);
  }

  return bundleDiscount;
}

function calculatePromoCodeDiscount( promoCode: PromoCodeType ) {
  let promoCodeDiscount = 0;

  switch( promoCode ) {
    case PromoCodeType.HOLIDAY: {
      break;
    }

    default: {
      // TODO: Notify User?
      console.warn("Invalid Promo Code");
    }
  }

  return calculatePromoCodeDiscount;
}







/* */
